import React from 'react'
import { emca_catalog } from '../../../../escalas/emca/emca.catalog'

// Example of emca: [ 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4 ]

// responses: [Muy de acuerdo, Bastante de acuerdo, Ni de acuerdo ni en desacuerdo, Bastante en desacuerdo, Muy en desacuerdo]

const rss = ["Muy de acuerdo", "Bastante de acuerdo", "Ni de acuerdo ni en desacuerdo", "Bastante en desacuerdo", "Muy en desacuerdo"]

export default function EmcaResults({ emca }) {
  if (!emca) return null

  const score = emca.reduce((a, v) => a + v, 0)

  return (
    <div>
      <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#e6f4ff', padding: 5, borderRadius: 6 }}>
        <td><strong>Puntuación total: {score}</strong></td>
      </tr>
      {emca_catalog.map((pr, i) => (
        <tr key={i} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: i % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
          <td>{pr}</td>
          <td>{rss[emca[i]]}</td>
        </tr>
      ))}
    </div>
  )
}
